<template>
  <JoszakiAutocomplete
    :value="value"
    v-bind="$attrs"
    icon="map-marked-alt"
    :items="filteredMiniMarkets"
    :loading="loading"
    @search="onSearch"
    @focus="onFocus"
    @input="$emit('input', $event)"
    v-on="$listeners"
  >
    <template #empty>
      {{ $t("conductor.common.noResults") }}
    </template>
  </JoszakiAutocomplete>
</template>

<script>
import { ref } from "@nuxtjs/composition-api";
import { useMiniMarketActions } from "~/components/_refactored/conductor/mini-markets/useMiniMarketActions";

export default {
  props: {
    value: {
      type: [Array, Object],
      default: () => null,
    },
  },
  setup(_props, { emit }) {
    const { getMiniMarkets } = useMiniMarketActions();
    const filteredMiniMarkets = ref([]);
    const loading = ref(false);

    const onSearch = async (search) => {
      loading.value = true;
      const { items } = await getMiniMarkets({
        search,
        page: 1,
        pageSize: 15,
      });
      filteredMiniMarkets.value = items;
      loading.value = false;
    };

    const onFocus = (search) => {
      onSearch(search ?? "");
      emit("focus", search);
    };

    return {
      filteredMiniMarkets,
      onSearch,
      onFocus,
      loading,
    };
  },
};
</script>
